module.exports = __webpack_public_path__ + "static/1-05da3e3b45e793e5681f7e081ba1ce8a.png";